(function($) {
	formHelper.addRule({
		form: '.user-stats',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);

jQuery(function initToolsSearchEvs1RiskMitigationReport($) {
	$('.user-stats-container').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#user-stats');

		// Date confirmation Range
		// ------------------
		var $confDateStart = $('#date-created-start').pickadate({
			max: 730,
			selectYears: 7,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var confDateStartPicker = $confDateStart.pickadate('picker');

		var $confDateEnd = $('#date-created-end').pickadate({
			max: 730,
			selectYears: 7,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var confDateEndPicker = $confDateEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( confDateStartPicker.get('value') ) {
			confDateEndPicker.set('min', confDateStartPicker.get('select'));
		}
		
		if ( confDateEndPicker.get('value') ) {
			confDateStartPicker.set('max', confDateEndPicker.get('select'));
		}

		// When something is selected, update the "confDateStart" and "confDateEnd" limits.
		confDateStartPicker.on('set', function(event) {
			if ( event.select ) {
				confDateEndPicker.set('min', confDateStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				confDateEndPicker.set('min', false);
			}
		});

		confDateEndPicker.on('set', function(event) {
			if ( event.select ) {
				confDateStartPicker.set('max', confDateEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				confDateStartPicker.set('max', false);
			}
		});

	});
});